import FormatListBulletedOutlinedIcon from "@mui/icons-material/FormatListBulletedOutlined";
import WindowOutlinedIcon from "@mui/icons-material/WindowOutlined";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import React from "react";

interface ListToggleButtonsProps {
  value: boolean;
  onChange: (
    event: React.MouseEvent<HTMLElement, MouseEvent>,
    value: any
  ) => void;
}

export const ListToggleButtons = ({ value, onChange }: ListToggleButtonsProps) => {
    const handleChange = (event: React.MouseEvent<HTMLElement, MouseEvent>, value: any) => {
        if (value === null) return;
        onChange(event, value);
    };

    return (
        <ToggleButtonGroup
            exclusive
            value={value}
            onChange={handleChange}
            sx={{ marginRight: ".5rem" }}
        >
            <ToggleButton value={true}>
                <FormatListBulletedOutlinedIcon />
            </ToggleButton>
            <ToggleButton value={false}>
                <WindowOutlinedIcon />
            </ToggleButton>
        </ToggleButtonGroup>
    );
};
